import { useCallback } from 'react';
import { Box, CircularProgress } from '@mui/material';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { MarketAdjustmentTableProps } from './types';

const MarketAdjustmentTable = ({ spreadsheets, onChange, format, formatDispatch, isLoadingMarketAdjustment }: MarketAdjustmentTableProps) => {
  const { marketAdjustmentSheet } = spreadsheets;

  const onSheetChange = useCallback(
    (cell, value) => {
      onChange(cell, value);
    },
    [onChange]
  );

  return (
    <Box position="relative">
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore: ScalarSpreadsheet is not typed */}
      <ScalarSpreadsheet
        {...marketAdjustmentSheet}
        id="market-adjustment-table"
        tableTerms={{ tableSlug: 'market-adjustment-table' }}
        onChange={onSheetChange}
        sheet={marketAdjustmentSheet}
        displayLegend={false}
        alwaysDisplayLegend={false}
        format={format}
        formatDispatch={formatDispatch}
      />
      {isLoadingMarketAdjustment && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          zIndex={1000}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default MarketAdjustmentTable;
